import sliderNames from './sliderNames';

export default {
  GET_ID_TOKEN: `${sliderNames.SESSIONS}/getIdToken`,
  ACCESS_SSO_LOGIN: `${sliderNames.SESSIONS}/accessSsoLogin`,
  LOGOUT: `${sliderNames.SESSIONS}/logout`,
  GET_USER_COMPANIES: `${sliderNames.COMPANIES}/getCompanies`,
};
